import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import {
    floorGameColor as color,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledLayout,
} from '@pkg/primitives';
import { FloorGameTierLabel } from '@pkg/types/app/floorGame';

import { tokens } from '../../tokens';

import { backgroundTransition, BackgroundVariant, backgroundVariants } from './Background.motion';

interface StyledBackgroundProps {
    $tier?: FloorGameTierLabel;
}

// Alternatively, we could nest this within `NftCard > Interior`
// and inherit the `border-radius + overflow`.
export const StyledBackground = styled(motion.div).attrs({
    variants: backgroundVariants,
    initial: BackgroundVariant.Hidden,
    animate: BackgroundVariant.Show,
    exit: BackgroundVariant.Hidden,
    transition: backgroundTransition,
})<StyledBackgroundProps>`
    ${styledInteraction.interactionDisable};
    ${styledLayout.positionCover()};

    --yat_nft-card-tier-shine-color: ${color.onyx};

    z-index: ${tokens.zindex.background};
    display: grid;
    border-radius: ${tokens.card.radius}px;
    overflow: hidden;

    ${({ $tier }) => {
        if ($tier === FloorGameTierLabel.Tier2) {
            return css`
                --yat_nft-card-tier-shine-color: ${color.blue};
            `;
        }

        if ($tier === FloorGameTierLabel.Tier3) {
            return css`
                --yat_nft-card-tier-shine-color: ${color.grape};
            `;
        }

        if ($tier === FloorGameTierLabel.Tier4 || $tier === FloorGameTierLabel.Tier5) {
            return css`
                --yat_nft-card-tier-shine-color: ${color.gold};
            `;
        }
    }};
`;

export const Interior = styled.div`
    display: grid;
    background-color: ${color.coal};
    // Setting color as the "current tier" allows us
    // to transition the linear-gradient.
    color: var(--yat_nft-card-tier-shine-color);
    transition: color ${duration.slow}ms ${easing.cubic};

    &::before {
        content: '';
        background: linear-gradient(28deg, ${color.coal} 26%, currentColor 80%, ${color.jet});
    }
`;
